const galleryId = 4;


const items = [];

let id = galleryId * 1000;
function addItemToGroup(item, tag) {
    id++;
    items.push({
        "id": id,
        "title": { "en": "" },
        "src": item,
        "tags": [tag],
        "groups": [galleryId],
        "ordering": id,
    });
}

let group = [];

group = ["sh_1399780019.jpg","sh_1761129356.jpg","sh_406753486.jpg","sh_1494043007.jpg","sh_1673668819.jpg","sh_373305709.jpg","sh_1732560446.jpg","sh_1730575804.jpg","sh_1731731929_2.jpg","sh_1720600744.jpg","sh_1829640635.jpg","sh_100424281.jpg","sh_1780338614.jpg","sh_1025099146.jpg","sh_1444882424.jpg","sh_1751364158.jpg","sh_1829640788.jpg","sh_1829640776.jpg","sh_1408362395.jpg","sh_1050054875.jpg","sh_1494043004.jpg","sh_1377554240.jpg","sh_1555107650.jpg","sh_1673668807.jpg","sh_744541786.jpg"];
group.forEach((i) => addItemToGroup(i, '1. Implants'));

group = ["sh_1634104033.jpg","sh_1634104021.jpg","sh_1634104015.jpg","sh_1634104030.jpg","sh_1634104024.jpg","sh_1634104036.jpg","sh_495859369.jpg","sh_1634104084.jpg"];
group.forEach((i) => addItemToGroup(i, '2. Implantation procedure'));

group = ["sh_33135199.jpg","sh_439956184.jpg","sh_97814549.jpg","sh_1856872432.jpg","sh_40507372.jpg","sh_40507375.jpg","sh_1856872426.jpg","sh_1747941452.jpg","sh_1710200257.jpg","sh_1710200260.jpg","sh_1807510033.jpg","sh_1179120508.jpg","sh_1306942741.jpg","sh_602233091.jpg","sh_1531728773.jpg","sh_714941401.jpg","sh_1856872423.jpg","sh_97814555.jpg","sh_1415937809.jpg","sh_1062433289.jpg","sh_1431586397.jpg","sh_1443620258.jpg","sh_1195248124.jpg"];
group.forEach((i) => addItemToGroup(i, '3. Accessories'));

group = ["sh_157037828.jpg","sh_273490913.jpg","sh_260028668.jpg","sh_260028659.jpg","sh_1547733968.jpg","sh_1710200197.jpg","sh_1710200164.jpg"];
group.forEach((i) => addItemToGroup(i, '4. Mini, Zirconium, Zygomatic'));

group = ["sh_1739391980.jpg","sh_1739391977.jpg","sh_601865408.jpg","sh_1713449395.jpg","sh_1399857905.jpg","sh_1583233564.jpg","sh_1311646634.jpg","sh_1277759158.jpg","sh_1376727602.jpg","sh_1713449392.jpg","sh_713522740.jpg","sh_1376727611.jpg","sh_1408362356.jpg","sh_1277759128.jpg","sh_1277759143.jpg","sh_1494043040.jpg","sh_1494043049.jpg","sh_1555107653.jpg","sh_1530693941.jpg","sh_1627811641.jpg","sh_227755375_1.jpg"];
group.forEach((i) => addItemToGroup(i, '5. Implant supported dentures'));

group = ["sh_1536189467.jpg","sh_1536186932.jpg","sh_1799056642.jpg","sh_1165261312.jpg","sh_1472018543.jpg","sh_1630719994.jpg","sh_154168097.jpg"];
group.forEach((i) => addItemToGroup(i, 'Before-after'));

group = ["sh_1669842505.jpg","sh_744541756.jpg","sh_1669842172.jpg","sh_1807510093.jpg","sh_1741122443.jpg","sh_767861803.jpg","sh_428431477.jpg","sh_1727881345.jpg","sh_1646434066.jpg","sh_1366012427.jpg","sh_1505970470.jpg","sh_1582203982.jpg","sh_1582203988.jpg","sh_1710200320.jpg","sh_1415937800.jpg","sh_1415937806.jpg","sh_1681902343.jpg","sh_1753852697.jpg","sh_1758922571.jpg","sh_1788283154.jpg","sh_1792459201.jpg","sh_1634104027.jpg","sh_1276663072.jpg","sh_531275926.jpg","sh_361782221.jpg","sh_88585900.jpg","sh_1277313793.jpg","sh_1308480106.jpg","sh_148553351.jpg","sh_1285175482.jpg","sh_1279399573.jpg","sh_1816569605.jpg","sh_82350499.jpg","sh_1294914247.jpg","sh_1165128304.jpg"];
group.forEach((i) => addItemToGroup(i, 'deleted'));

group = ["sh_1624380457a.jpg","sh_1797219922a.jpg"];
group.forEach((i) => addItemToGroup(i, 'x_new'));

export default items;
